'use client';

import { Box, Stack } from '@mui/material';
import ScrollProgress from '@/app/components/scroll-progress';
import MasterLayout from '@/app/components/layout/master-layout';
import DeviceManageLayout from '@/app/components/layouts/device-manage';
import { PrivacyPolicyContent } from './privacy-policy-content';

export default function PrivacyPolicy() {
  return (
    <MasterLayout>
      <ScrollProgress />
      <DeviceManageLayout
        title="Privacy Policy"
        description="Your privacy is our priority; we protect your personal information with utmost care and transparency."
      >
        <Box
          sx={{
            mx: 'auto',
            width: {
              md: '100%',
              lg: '1200px',
            },
            pl: 3,
            pr: 3,
          }}
        >
          <Stack gap={8}>
            <PrivacyPolicyContent />
          </Stack>
        </Box>
      </DeviceManageLayout>
    </MasterLayout>
  );
}
